<template>
  <div class="inpbox-container">
    <div class="inpbox">
      <input type="text" v-model.lazy="input_text" :placeholder="placeholder">
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
  name : 'retro-input',
  props : {
    placeholder : {
      type : String,
      default : "Add text here"
    },
    value : {
      type : String,
      default : ''
    }
  },
  data(){
    return {
      input_text: this.value
    }
  },
  watch : {
    input_text(new_val){
      this.$emit('input', new_val)
    }
  },
}
</script>
<style scoped>
.inpbox-container .inpbox {
  margin-bottom: 30px;
  display: inline-block;
  position: relative;
  width: 100%;
}
.inpbox-container .inpbox input {
  padding: 5px 10px;
  height: 45px;
  font-size: 1em;
  line-height: 45px;
  border: 2px solid rgb(86, 11, 173);
  outline: none;
  background: #fff;
  color: #000;
  width: 100%;
}
.inpbox-container .inpbox input:focus + span {
  width: 100%;
  opacity: 1;
  transform: translateX(0);
}
.inpbox-container .inpbox input:focus + span:before {
  top: 0;
  left: 0;
  width: 100%;
}
.inpbox-container .inpbox input:focus + span:after {
  bottom: 0;
  left: 0;
  width: 100%;
}
.inpbox-container .inpbox input + span {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  border-left: 2px solid #0099ef;
  border-right: 2px solid #0099ef;
  width: calc(100% + 100px);
  transform: translateX(-50px);
  height: 100%;
  pointer-events: none;
  opacity: 0;
  transition-property: opacity, width;
  transition: 0.3s ease-out;
}
.inpbox-container .inpbox input + span:before, .inpbox-container .inpbox input + span:after {
  content: "";
  display: inline-block;
  position: absolute;
  left: 25px;
  transition-property: top, bottom;
  transition: 0.3s ease-out;
  height: 2px;
  width: calc(100% - 50px);
  background: #0099ef;
}
.inpbox-container .inpbox input + span:before {
  top: -30px;
}
.inpbox-container .inpbox input + span:after {
  bottom: -30px;
}
</style>